import { Link, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";
import { useProduct } from "@/api/hooks";
import { usePageCrumbs } from "@/components/shell/breadcrumb";
import { labelRef } from "@/components/domain/LabelPrintButton";
import { PageBody, PageHeader } from "@/components/ui/PageHeader";
import { Panel } from "@/components/ui/Panel";
import { buttonStyles } from "@/components/ui/Button";
import { LoadingState, ErrorState } from "@/components/ui/States";
import { ProductStockPanel } from "@/components/products/ProductStockPanel";

export function ProductStockPage() {
  const { id } = useParams();
  const { search } = useLocation();
  const { t } = useTranslation();
  const { data, isLoading, refetch } = useProduct(id);
  const identity = data ? labelRef(data.productCode, data.subRef) : "";
  usePageCrumbs(data ? [{ label: identity, to: `/products/${id}${search}` }, { label: t("productWorkspace.inventory") }] : [], `/products${search}`);
  if (isLoading) return <PageBody><LoadingState /></PageBody>;
  if (!data) return <PageBody><ErrorState message={t("products.errorLoad")} onRetry={() => void refetch()} /></PageBody>;
  return <PageBody className="space-y-4">
    <Link to={`/products/${id}${search}`} className={buttonStyles({ variant: "ghost", size: "sm" })}><ArrowLeft className="size-4" /> {identity}</Link>
    <PageHeader title={t("productWorkspace.inventory")} subtitle={identity} />
    <Panel className="p-5"><ProductStockPanel product={data} /></Panel>
  </PageBody>;
}
